import { styled } from '@arpeggi/ui'

const Root = styled('button', {
  all: 'unset',
  width: '48px',
  height: '48px',
  borderRadius: '999px',
  color: '$white',
  background: '$black',
  display: 'flex',
  fontSize: '12px',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 100ms ease',
  boxShadow: '0px 0px 10px -2px rgba(0, 0, 0, 0.25)',
  '&:hover': {
    opacity: 0.9
  },
  '&:active': {
    opacity: 0.8
  },
  '&:disabled': {
    opacity: 0.3
  }
})

const Icon = styled('svg', {
  width: '20px',
  height: '20px'
})

export const PlaybackButton = { Root, Icon }
